<template>
  <div class="app-container">
    <div>
      <list ref="list">
        <template slot="toolbar-right">
          <el-button v-if="$permission.canImport()" type="success" plain @click="onImprot()">导入</el-button>
          <el-button v-if="$permission.canImport()" type="primary" plain @click="onImprot2()">导入附件</el-button>
          <el-button v-if="$permission.canWrite()" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
          <el-button type="danger" v-if="$permission.canDel()" @click="delRows">删除</el-button>
          <el-button v-if="$permission.canRecord()" type="success" @click="record">备案</el-button>
          <el-button v-if="$permission.canRecord()" type="warning"  @click="unRecord">解除备案</el-button>
        </template>
        <template slot="column">
          <el-table-column 
            label="操作" 
            fixed="right" 
            align="center" 
            width="90" 
          >
            <template slot-scope="{row}">
              <el-button type="text" size="medium" @click="editById(row.CoachId)" v-if="$permission.canEdit()" icon="el-icon-edit" title="编辑"></el-button>
              <el-button type="text" size="medium" @click="details(row)" icon="el-icon-document" title="查看"></el-button>
              <el-button type="text" size="medium" @click="delRow(row.CoachId)" icon="el-icon-delete" v-if="$permission.canDel()&&row.Status!=3&&(row.RecordStatus==0||row.RecordStatus==2)" title="删除"></el-button>
            </template>
          </el-table-column>
        </template>
      </list>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <view-dialog ref="viewDialog" @close-saved="reload"></view-dialog>
    <import-dialog ref="importDialog" @upload-success="reload" />
    <importpic-dialog ref="importpicDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/schoolmanage/safemember/list";
import editDialog from "@/components/schoolmanage/safemember/editDialog";
import viewDialog from "@/components/schoolmanage/safemember/viewDialog";
import importDialog from "@/components/schoolmanage/safemember/importDialog";
import importpicDialog from "@/components/schoolmanage/coach/importpicDialog";

export default {
  name: "safemember",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    viewDialog,
    importDialog,
    importpicDialog
  },
  data() {
    return {
      data: {
        
      },
      api: require("@/api/schoolmanage/coach").default,
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    details(row) {
      this.$refs.viewDialog.openEditById(row.CoachId);
    },
    // beforeCreate() {
    //   this.$refs.selectDialog.open();
    // },
    // create(DpType) {
    //   if(DpType==2) {
    //     this.$refs.editDialog.openCreate({DpType});
    //   } else {
    //     this.$refs.dpDialog.openCreate({DpType});
    //   }
    // },
    // toEditById(row) {
    //   if(row.DpType==2) {
    //     this.$refs.editDialog.openEditById(row.CoachId);
    //   } else {
    //     this.$refs.dpDialog.openEditById(row.CoachId);
    //   }
    // },
    lock() {
      this.$message.warning("暂未开放");
    },
    record() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要备案的数据");
        return;
      }
      var obj = rows.find(x => x.Status!=3);
      if(obj) return this.$message.error("已审批的记录才可以备案");
      
      this.$confirm("确认备案所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let Ids = rows.map((item) => {
            return item.CoachId;
          });
          this.api.record({ Ids }).then(res => {
            if(res.Code==0) {
              this.reload();
              this.$message.success(res.Msg);
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => {});
    },
    unRecord() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要解除备案的数据");
        return;
      }
      var obj = rows.find(x => x.RecordStatus!=3);
      if(obj) return this.$message.error("备案通过的记录才可以解除备案");
      
      this.$confirm("确认解除所选数据的备案吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let Ids = rows.map((item) => {
            return item.CoachId;
          });
          this.api.unRecord({ Ids }).then(res => {
            if(res.Code==0) {
              this.reload();
              this.$message.success(res.Msg);
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => {});
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.CoachId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    delRow(id) {
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.delRange([id]);
        })
        .catch(() => {});
    },
    onImprot() {
      this.$refs.importDialog.open();
    },
    onImprot2() {
      this.$refs.importpicDialog.open();
    },
  },
};
</script>
<style lang="less" scoped>
</style>